module.exports = __webpack_public_path__ + "static/media/vl.cdaa251e.jpg";